import React, { lazy } from 'react'
import { Route } from 'react-router'
import { Routes } from 'react-router-dom'

import AccountLayout from './components/layouts/AccountLayout'
import AppLayout from './components/layouts/AppLayout'
import { ROUTES } from './constants/routes'
import { usePageViewListener } from './hooks/usePageViewListener'

const AccountPage = lazy(() => import('./pages/account/index/AccountPage'))
const AddContactPage = lazy(() => import('./pages/contacts/add/AddContactPage'))
const AddTagPage = lazy(() => import('./pages/tags/add/AddTagPage'))
const ContactDetailsPage = lazy(
  () => import('./pages/contacts/details/ContactDetailsPage'),
)
const ContactListPage = lazy(
  () => import('./pages/contacts/list/ContactListPage'),
)
const DebugPage = lazy(() => import('./pages/debug/index/DebugPage'))
const DebugReleasePage = lazy(
  () => import('./pages/debug/release/DebugReleasePage'),
)
const DebugSentryPage = lazy(
  () => import('./pages/debug/sentry/DebugSentryPage'),
)
const EditContactPage = lazy(
  () => import('./pages/contacts/edit/EditContactPage'),
)
const EditTagPage = lazy(() => import('./pages/tags/edit/EditTagPage'))
const EmailVerificationRequiredPage = lazy(
  () =>
    import(
      './pages/account/email-verification-required/EmailVerificationRequiredPage'
    ),
)
const ForgotPasswordPage = lazy(
  () => import('./pages/account/forgot-password/ForgotPasswordPage'),
)
const IndexPage = lazy(() => import('./pages/index/IndexPage'))
const LoginPage = lazy(() => import('./pages/auth/login/LoginPage'))
const NotFoundPage = lazy(() => import('./pages/404/NotFoundPage'))
const RegisterPage = lazy(() => import('./pages/account/register/RegisterPage'))
const ResetPasswordPage = lazy(
  () => import('./pages/account/reset-password/ResetPasswordPage'),
)
const TagDetailPage = lazy(() => import('./pages/tags/details/TagDetailPage'))
const TagsListPage = lazy(() => import('./pages/tags/list/TagsListPage'))
const UpdatePasswordPage = lazy(
  () => import('./pages/settings/update-password/UpdatePasswordPage'),
)
const VerifyEmailPage = lazy(
  () => import('./pages/account/verify-email/VerifyEmailPage'),
)

const AppRoutes: React.FC = () => {
  usePageViewListener()

  return (
    <Routes>
      <Route path="" element={<IndexPage />} />

      <Route element={<AccountLayout />}>
        {/* Account */}
        <Route path={ROUTES._login} element={<LoginPage />} />
        <Route path={ROUTES._register} element={<RegisterPage />} />
        <Route path={ROUTES._forgotPassword} element={<ForgotPasswordPage />} />
        <Route path={ROUTES._resetPassword} element={<ResetPasswordPage />} />
      </Route>

      <Route element={<AppLayout />}>
        {/* Contacts */}
        <Route path={ROUTES._contactList} element={<ContactListPage />} />
        <Route path={ROUTES._contactDetails} element={<ContactDetailsPage />} />
        <Route path={ROUTES.contacts.add} element={<AddContactPage />} />
        <Route path={ROUTES.contacts.edit} element={<EditContactPage />} />

        {/* Debug */}
        <Route path={ROUTES._debug} element={<DebugPage />} />
        <Route path={ROUTES._debugRelease} element={<DebugReleasePage />} />
        <Route path={ROUTES._debugSentry} element={<DebugSentryPage />} />

        {/* Debug */}
        <Route path={ROUTES._tagList} element={<TagsListPage />} />
        <Route path={ROUTES._tagDetails} element={<TagDetailPage />} />
        <Route path={ROUTES._addTag} element={<AddTagPage />} />
        <Route path={ROUTES._editTag} element={<EditTagPage />} />

        {/* Misc */}
        <Route
          path={ROUTES._emailVerificationRequired}
          element={<EmailVerificationRequiredPage />}
        />
        <Route path={ROUTES._verifyEmail} element={<VerifyEmailPage />} />
        <Route path="*" element={<NotFoundPage />} />

        {/* Settings */}
        <Route path={ROUTES._account} element={<AccountPage />} />
        <Route path={ROUTES._updatePassword} element={<UpdatePasswordPage />} />
      </Route>

      {/* Misc */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRoutes
